<mat-card appearance="outlined">
  <form tabindex="0" class="fix-editor">
    <mat-form-field class="ag-row fix-mat-form"
                    [style.width]="width">
      <input #alphanumericInput matInput tabindex="0"
             [formControl]="formControl"
             [errorStateMatcher]="matcher">
      <mat-error *ngIf="formControl.hasError('required')">
          {{ 'se-ui-datagrid_required_value_constraint' | translate }}
      </mat-error>
    </mat-form-field>
  </form>
</mat-card>
